import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from '../../../common/hooks/useIsMobile';

const SsmoPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  width: 480px;
  margin-block: 32px;
  align-items: center;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: auto;
    padding-inline: 16px;
    margin-block: 24px;
  }
`;

export default SsmoPageWrapper;
